export const BOOK_A_DEMO_URL = 'https://www.peppercontent.io/book-a-demo'
export const CMP_SALES_CONTACT_URL = 'https://calendly.com/d/2gj-b8y-vc7'
export const CMP_UPGRADE_NOW_URL = 'STRIPE-PAYMENT'
export const MARKETPLACE_KNOW_MORE_URL =
  'https://peppercontent.io/product/talent-marketplace'
